export enum EnumPeriodo {
  Periodo1 = 1,
  Periodo2,
  Periodo3,
  Periodo4,
  Periodo5,
  Periodo6,
  Periodo7
}
